const API_SETTING = process.env.NODE_ENV === 'development' ? 
{ // dev
    adserverAPI: {
        url: 'https://allapi-dev.adpopcorn.com',
        prefix: '/V3/API',
    },
    audienceAPI: {
        url: 'https://s62rof70v2.execute-api.ap-northeast-1.amazonaws.com',
        prefix: '/dev',
    },
}
:
{ // live
    adserverAPI: {
        url: 'https://allapi-live.adpopcorn.com',
        prefix: '/V3/API',
    },
    audienceAPI: {
        url: 'https://s62rof70v2.execute-api.ap-northeast-1.amazonaws.com',
        prefix: '/prod',
    },
}
export default API_SETTING;